import * as httpClient from '../httpClient';
import { getCurrentLocale } from '../language';
import { cookiesLib } from '../cookies';
import { getConfig } from '../../config/portal';
import { extractProductPath } from '../product/urlHelper';
import { productTypes, moorings } from '../product/constants';

const generateProductPortalLink = (listing) => {
  let origin = window?.location?.origin;
  const pathname = window?.location?.pathname;

  // To allow local development
  if (origin?.includes('localhost')) {
    origin = getConfig()?.host;
  }
  /* TODO: PRIME-2024 - Add dynamic routing for Moorings */
  const extractedPathname = extractProductPath(pathname, Array.from(moorings));

  if (origin && extractedPathname) {
    return `${origin}${extractedPathname}?listingId=${listing.id}`;
  }
  return '';
};

export const prepareLeadData = (listing, formFields, leadSource, leadType) => {
  const { id } = listing;
  const partyId =  listing.ownerId || listing.owner?.id;
  const leadData = {
    id: partyId,
    source: leadSource,
    formFields: formFields,
    type: leadType,
    imtId: id,
    ...(productTypes[listing.type] && {
      portalUrl: generateProductPortalLink(listing),
    }),
  };
  leadData.gaClientID = cookiesLib.get('_ga');
  return leadData;
};

export const sendLead = (leadData) => {
  let lead = buildLead(leadData);
  lead.locale = getCurrentLocale(true);
  return httpClient.getHttpClient().post('/lead', lead);
};

const buildLead = (leadData) => {
  let fullName = leadData.formFields.name.split(' ');
  const lastName = fullName.pop();
  const firstName = fullName.join(' ');
  const lead = {
    id: leadData.id,
    leadSource: leadData.source,
    gaClientID: leadData.gaClientID,
    type: leadData.type,
    customer: {
      firstName: firstName,
      lastName: lastName,
      email: leadData.formFields.email,
      comments: leadData.formFields.comments,
      phone: {
        type: 'Phone',
        number: leadData.formFields.phone
      },
      address: {
        ...(leadData.formFields.zip && { zip: leadData.formFields.zip }),
        ...(leadData.formFields.country && {
          country: leadData.formFields.country
        })
      },
    },
    ...(leadData.portalUrl && {
      portalUrl: leadData.portalUrl
    }),
  };

  if (leadData.copyOem) {
    lead.copyOem = leadData.copyOem;
  }

  if (leadData.oemId) {
    lead.oemId = leadData.oemId;
  }
  if (leadData.brandId) {
    lead.brandId = leadData.brandId;
  }

  if (leadData.imtId) {
    lead.imtId = leadData.imtId;
  }

  return lead;
};
